export function ShoppingCartIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M1 2H2.5L4.79688 10.2675C4.85533 10.4781 4.98114 10.6637 5.15507 10.796C5.32901 10.9282 5.54148 10.9999 5.76 11H11.9375C12.1561 11 12.3687 10.9284 12.5428 10.7961C12.7169 10.6638 12.8428 10.4782 12.9012 10.2675L14.5 4.5H3.19438"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 14.375C5.98325 14.375 6.375 13.9832 6.375 13.5C6.375 13.0168 5.98325 12.625 5.5 12.625C5.01675 12.625 4.625 13.0168 4.625 13.5C4.625 13.9832 5.01675 14.375 5.5 14.375Z"
        fill="currentColor"
      />
      <path
        d="M12 14.375C12.4832 14.375 12.875 13.9832 12.875 13.5C12.875 13.0168 12.4832 12.625 12 12.625C11.5168 12.625 11.125 13.0168 11.125 13.5C11.125 13.9832 11.5168 14.375 12 14.375Z"
        fill="currentColor"
      />
    </svg>
  );
}
